module.exports = __webpack_public_path__ + "static/g-AGarcia-2f7106299a46d457f26ccd464520c413.jpg";